import { AppAPI, } from '@moderepo/mode-apis';
import { searchParamsToString, } from '@moderepo/mode-data-state-base';
/**
 * The types of action that can be dispatched to update this sub state.
 */
export var VideosActionType;
(function (VideosActionType) {
    VideosActionType["SET_VIDEOS"] = "set videos";
    VideosActionType["CLEAR_VIDEOS"] = "clear videos";
})(VideosActionType || (VideosActionType = {}));
export const setHomeVideos = (homeId, smartModuleId, videos, searchParams) => {
    return {
        type: VideosActionType.SET_VIDEOS,
        homeId,
        smartModuleId,
        videos,
        searchParams,
    };
};
/**
 * Create an action for clearing all the cache video for the specified home
 */
export const clearVideos = (homeId, smartModuleId) => {
    return {
        type: VideosActionType.CLEAR_VIDEOS,
        homeId,
        smartModuleId,
    };
};
/**
 * Fetch videos for a home
 */
export const fetchHomeVideos = (homeId, smartModuleId, filters) => {
    return async (dataDispatch) => {
        const modifiedFilters = {
            ...filters,
            // change pageSize/pageNumber to skip/limit
            skip: (filters === null || filters === void 0 ? void 0 : filters.pageNumber) && filters.pageSize ? filters.pageNumber * filters.pageSize : undefined,
            limit: (filters === null || filters === void 0 ? void 0 : filters.pageSize) ? filters.pageSize : undefined,
            // exclude pageSize/pageNumber
            pageNumber: undefined,
            pageSize: undefined,
        };
        const response = await AppAPI.getInstance().getHomeVideos(homeId, smartModuleId, modifiedFilters);
        await dataDispatch(setHomeVideos(homeId, smartModuleId, response, searchParamsToString(filters)));
    };
};
/**
 * Delete home videos for the given searchKey. NOTE: this will delete all videos that has the same searchKey
 */
export const deleteHomeVideos = (homeId, smartModuleId, searchKey) => {
    return async (dataDispatch) => {
        await AppAPI.getInstance().deleteHomeVideos(homeId, smartModuleId, searchKey);
        await dataDispatch(clearVideos(homeId, smartModuleId));
    };
};
